import { RootState } from '../reducers'

export const signalementsSelector = (state: RootState) => (state.signalements ? state.signalements.paging.content : [])

export const lastPageSelector = (state: RootState) => (state.signalements.paging ? state.signalements.paging.last : null)

export const signalementsPagingSelector = (state: RootState) => state.signalements.paging

export const signalementItemSelector = (state: RootState, id: number) => state.signalements.items && state.signalements.items[id]
